// import Vue from 'vue'
import axios from 'axios'
import {
  baseURL,
  contentType,
  // debounce,
  // messageName,
  requestTimeout,
  statusName,
  successCode,
  /* tokenName, */
} from '@/config/net.config.js'
import store from '@/store'
import qs from 'qs'
import router from '@/router'
import { isArray } from '@/utils/validate'
// import { needErrorLog, addErrorLog } from '@/vab/plugins/errorLog'

let loadingInstance

// 操作正常Code数组
const codeVerificationArray = isArray(successCode)
  ? [...successCode]
  : [...[successCode]]

/**
 * axios响应拦截器
 * @param data response数据
 * @param status HTTP status
 * @param statusText HTTP status text
 * @returns {Promise<*|*>}
 */
const handleData = async ({ data, status = 0 }) => {
  if (loadingInstance) loadingInstance.close()
  // 若data.code存在，覆盖默认code
  let code = data && data[statusName] ? data[statusName] : status
  // 若code属于操作正常code，则code修正为200
  if (codeVerificationArray.indexOf(code) + 1) code = 200
  switch (code) {
    case 200:
      // 业务层级错误处理，以下是假定restful有一套统一输出格式(指不管成功与否都有相应的数据格式)情况下进行处理
      // 例如响应内容：
      // 错误内容：{ code: 1, msg: '非法参数' }
      // 正确内容：{ code: 200, data: {  }, msg: '操作正常' }
      // return data
      return data
    case 401:
      store
        .dispatch('user/resetAll')
        .then(() =>
          router.push({ path: '/login', replace: true }).then(() => {})
        )
      break
    case 403:
      router.push({ path: '/403' }).then(() => {})
      break
  }
  return Promise.reject(data)
}

/**
 * @description axios初始化
 */
const instance = axios.create({
  baseURL,
  timeout: requestTimeout,
  headers: {
    'Content-Type': contentType,
  },
})

/**
 * @description axios请求拦截器
 */
instance.interceptors.request.use(
  (config) => {
    let token = store.getters.getStorage
    if(config.token!=null){
      token=config.token
    }
    // 不规范写法 可根据setting.config.js tokenName配置随意自定义headers
    if (token) config.headers['Authorization'] = token
    if (config.head) config.headers['Content-Type'] = config.head
    // 规范写法 不可随意自定义
    // if (token) config.headers['Authorization'] = `Bearer ${token}`
    // console.log(config)
    if (config.head && config.head === 'application/json;charset=UTF-8') {
      config.headers['Content-Type'] = config.head
    }
    if (
      config.data &&
      config.headers['Content-Type'] ===
        'application/x-www-form-urlencoded;charset=UTF-8'
    )
      config.data = qs.stringify(config.data)
    // if (debounce.some((item) => config.url.includes(item)))
    //   loadingInstance = Vue.prototype.$baseLoading()
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

/**
 * @description axios响应拦截器
 */
instance.interceptors.response.use(
  (response) => handleData(response),
  (error) => {
    const { response = {} } = error
    return handleData(response)
  }
)

export default instance
